import './styles.css';
import { useSoonModal } from './SoonModal/SoonModalContext';

export function Button({ as = 'a', variant = 'primary', className = '', href, onClick, soon, children, ...rest }) {
  const { openSoonModal } = useSoonModal();
  const classes = ['btn', variant === 'secondary' ? 'btnSecondary' : 'btnPrimary', className]
    .filter(Boolean)
    .join(' ');

  const handleClick = (e) => {
    if (soon) {
      e.preventDefault();
      openSoonModal();
    }
    onClick?.(e);
  };

  if (soon || as === 'button') {
    return (
      <button type="button" className={classes} onClick={handleClick} {...rest}>
        {children}
      </button>
    );
  }

  return (
    <a className={classes} href={href} onClick={handleClick} {...rest}>
      {children}
    </a>
  );
}

